import { Trans } from '@lingui/macro';

import { Display, Flex, Text } from '@rover/kibble/core';
import GroomingNewBadge from '@rover/react-lib/src/pages/grooming/components/GroomingNewBadge';
import useInGroomingPilot from '@rover/react-lib/src/pages/grooming/hooks/useInGroomingPilot';

import { ServiceDescription } from '../../utilities/serviceDescriptionUtils';

import ServiceCategoryTabs from './ServiceCategoryTabs';
import { getServiceOverviewCategories } from './ServiceOverview.constants';

type Props = {
  availableServices: ServiceDescription[];
  hasPetInsurance?: boolean;
  defaultActiveTabId?: string;
};

const ServiceOverview = ({
  availableServices,
  hasPetInsurance,
  defaultActiveTabId,
}: Props): JSX.Element => {
  const { shouldShowGroomingEntrypoints } = useInGroomingPilot();
  const serviceOverviewCategories = getServiceOverviewCategories(
    availableServices,
    hasPetInsurance,
    shouldShowGroomingEntrypoints
  ).map((tab) => ({
    ...tab,
    icon: tab.id === 'other' && shouldShowGroomingEntrypoints ? GroomingNewBadge : undefined,
  }));

  return (
    <Flex
      flexDirection="column"
      alignItems="flex-start"
      gap="0x"
      mb="4x"
      paddingTop={['8x', '12x']}
    >
      <Display size="400" mb="1x">
        <Trans>Get to know services on Rover</Trans>
      </Display>
      <Text mb="8x">
        <Trans>Get the care your pet needs, anytime and anywhere.</Trans>
      </Text>
      <ServiceCategoryTabs
        services={serviceOverviewCategories}
        defaultActiveTabId={defaultActiveTabId}
      />
    </Flex>
  );
};

export default ServiceOverview;
